import links from "../../partials/links";
import {
  page_of_cheques,
  page_of_four,
  page_of_recent,
  page_of_three,
  page_of_hero,
  hero_content,
  grid_of_facts,
} from "../../partials/pages";

const home = {
  label: "Home Page Settings",
  name: "home",
  file: "content/setting/home.md",

  fields: [
    {
      label: "Template",
      name: "template",
      widget: "hidden",
      default: "home",
      required: true,
    },
    links("Social links", "social_links"),
    links("Header Links", "header_links"),
    {
      label: "Footer",
      name: "footer",
      widget: "list",
      types: [
        {
          label: "Column",
          name: "column",
          widget: "object",
          collapsed: true,
          fields: [
            {
              label: "Title",
              name: "title",
              widget: "string",
              required: true,
            },
            links("Links", "links"),
          ],
        },
        {
          label: "Middle",
          name: "middle",
          widget: "object",
          collapsed: true,
          fields: [
            {
              label: "Title",
              name: "title",
              widget: "string",
              required: true,
            },
            links("Links", "links"),
          ],
        },
        {
          label: "Right",
          name: "right",
          widget: "object",
          collapsed: true,
          fields: [
            {
              label: "Title",
              name: "title",
              widget: "string",
              required: true,
            },
            links("Links", "links"),
          ],
        },
      ],
    },
    {
      label: "Pages",
      name: "pages",
      widget: "list",
      types: [
        page_of_three(),
        page_of_four(),
        page_of_cheques(),
        page_of_recent(),
        page_of_hero(),
        grid_of_facts(),
      ],
    },
  ],
};

export default home;
